import {Injectable} from '@angular/core';
import {MdMarket} from '../models/models';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class MdMarketService {

  constructor(private httpClient: HttpClient) {
  }

  getMarketsForDadConfig(dadConfigName: string): Observable<MdMarket[]> {
    return this.httpClient.get<MdMarket[]>(environment.baseUrlWs + '/api/markets?exchange.dadConfig.name=' + dadConfigName);
  }
}
